import styled, { keyframes } from "styled-components";

export const fade = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const PodcastImageWrapper = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  flex-shrink: 0;

  @media (hover: hover) {
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 1;
    }
  }
`;

export const PodcastImage = styled.img`
  aspect-ratio: 1/1;
  width: 120px;
  transition: transform 0.3s ease;
  object-fit: cover;
  border-radius: 12px;
  height: 120px;
  aspect-ratio: 1/1;

  @media (max-width: 699px) {
    min-width: auto;
    max-width: 64px;
    height: 64px;
  }
`;

export const PodcastCard = styled.li`
  width: 100%;
  opacity: 0;
  animation: ${fade} ${(props) => props.duration + "ms"} forwards;
  animation-timing-function: cubic-bezier(0 0 0.58 1);
  animation-delay: 100ms;
  cursor: pointer;

  display: flex;
  gap: 12px;

  &:hover {
    ${PodcastImageWrapper} {
      &::before {
        opacity: 1;
        transition: opacity 0.1s ease;
      }
    }

    ${PodcastImage} {
      transform: scale(1.05);
    }
  }
`;

export const PodcastTitle = styled.h4`
  line-height: 120%;
  font-size: 20px;
  font-weight: 900;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const PodcastInfo = styled.div`
  color: #ffffff;
  display: flex;
  align-items: stretch;
  gap: 4px;
  line-height: normal;
  white-space: nowrap;

  @media (max-width: 1252px) {
    p {
      font-size: 14px;
    }
  }
`;

export const PodcastInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 699px) {
    > :nth-child(2) {
      order: 3;
    }
    > :nth-child(3) {
      order: 2;
    }
  }
`;

export const PodcastRatingStar = styled.img`
  margin-right: 4px;

  @media (max-width: 899px) {
    width: 16px;
  }
`;

export const PodcastDescription = styled.p`
  margin-top: 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  @media (max-width: 699px) {
    margin-top: 0;
  }
`;

export const LiveFlag = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 24px;
  border: 1px solid var(--card-default);

  span {
    color: var(--background-primary);
    line-height: normal;
  }
`;
